import { useQuery } from 'react-query'
import type { AxiosError } from 'axios'
import {
  fetchCalculatorCards,
  fetchCalculatorDictionary,
  fetchCalculatorMetadata,
} from '../api/calculatorApi'
import type {
  CalculatorCardsResponse,
  CalculatorDictionary,
  CalculatorMetadataResponse,
} from '../types'
import { CALCULATOR_KEYS } from './calculatorKeys'

/** Правки админа в справочнике доезжают в пределах минуты — столько и держим. */
const DICTIONARY_STALE_MS = 60 * 1000

/**
 * Перечисления: единицы измерения и типы форм с их размерами.
 *
 * Меняются между релизами бэкенда, поэтому запрашиваем раз за сессию. Набор
 * размеров формы берём отсюда, а не из кода: у прямоугольника нет диаметра, и
 * рисовать это поле не нужно.
 */
export const useCalculatorMetadataQuery = (enabled = true) =>
  useQuery<CalculatorMetadataResponse, AxiosError>(
    CALCULATOR_KEYS.metadata,
    fetchCalculatorMetadata,
    {
      enabled,
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false,
    }
  )

/**
 * Справочник блоков и ингредиентов — им подписываются идентификаторы из
 * состава рецепта и корзины, своих названий те не несут.
 */
export const useCalculatorDictionaryQuery = (enabled = true) =>
  useQuery<CalculatorDictionary, AxiosError>(
    CALCULATOR_KEYS.dictionary,
    fetchCalculatorDictionary,
    {
      enabled,
      staleTime: DICTIONARY_STALE_MS,
      refetchOnWindowFocus: false,
      retry: false,
    }
  )

/** Карточки, у которых калькулятор опубликован. */
export const useCalculatorCardsQuery = (enabled = true) =>
  useQuery<CalculatorCardsResponse, AxiosError>(
    CALCULATOR_KEYS.cards,
    fetchCalculatorCards,
    {
      enabled,
      staleTime: DICTIONARY_STALE_MS,
      refetchOnWindowFocus: false,
      retry: false,
    }
  )
